import { type RefObject, useCallback } from 'react'

/**
 * Hook that provides a function to scroll an element to its bottom
 * @param ref Reference to the element to scroll
 * @returns A function that scrolls the element to its bottom
 */
export function useScrollToBottom<T extends HTMLElement>(ref: RefObject<T | null>): () => void {
  const scrollToBottom = useCallback(() => {
    if (ref.current) {
      const element = ref.current
      element.scrollTop = element.scrollHeight
    }
  }, [ref])

  return scrollToBottom
}
